import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MailService } from 'src/app/services/mail/mail.service';
import { SnackBarService } from 'src/app/services/snackBar/snack-bar.service';
import { TicketsService } from 'src/app/services/tickets/tickets.service';

@Component({
  selector: 'app-caso-verify',
  templateUrl: './caso-verify.component.html',
  styleUrls: ['./caso-verify.component.scss'],
})
export class CasoVerifyComponent implements OnInit, OnDestroy {
  private destroyed$ = new Subject<void>();

  hash: string = '';

  constructor(
    private route: ActivatedRoute,
    private snackBarService: SnackBarService,
    private translocoService: TranslocoService,
    private mailService: MailService,
    private ticketsService: TicketsService
  ) {}

  ngOnInit(): void {
    this.route.queryParamMap
      .pipe(takeUntil(this.destroyed$))
      .subscribe((params) => {
        const email = params.get('email') || '';
        const ticketId = Number(params.get('ticketId'));
        const serialNumber = params.get('serialNumber') || '';
        const username = params.get('username') || '';
        const seguimiento = params.get('seguimiento') === 'true';

        this.verifyCaso(email, ticketId, serialNumber, username, seguimiento);
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  showSnackBarSuccess(mensaje: string) {
    this.snackBarService.openSnackBarSuccess(mensaje);
  }

  showSnackBarError(mensaje: string) {
    this.snackBarService.openSnackBarError(mensaje);
  }

  verifyCaso(
    email: string,
    ticketId: number,
    serialNumber: string,
    username: string,
    seguimiento: boolean
  ) {
    this.ticketsService
      .changeStatusTicketClient(ticketId, 'new')
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: () => {
          this.mailService
            .sendMailConfirmacion(
              email,
              ticketId,
              serialNumber,
              username,
              seguimiento
            )
            .pipe(takeUntil(this.destroyed$))
            .subscribe({
              error: (e) => console.error(e),
            });

          this.showSnackBarSuccess(
            this.translocoService.translate('issue.success.issueCreated')
          );
        },
        error: (e) => {
          console.error(e);
          this.showSnackBarError(
            this.translocoService.translate('issue.error.issueCreated')
          );
        },
      });
  }
}
